import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Bodenbelaege = () => {
  const pageData = {
    title: 'BODENBELÄGE',
    subtitle: 'Parkett, Laminat & Vinyl',
    description: 'Professionelle Verlegung hochwertiger Bodenbeläge. Von edlem Parkett über robustes Laminat bis hin zu pflegeleichtem Vinyl – wir schaffen die perfekte Grundlage für Ihr Zuhause.',
    heroImage: 'https://images.unsplash.com/photo-1761053133165-0f3acdaf1770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxwYXJxdWV0JTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb24lMjB3b29kJTIwZmxvb3IlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzc2NDMxODh8MA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Parkett', description: 'Edle Echtholzböden in verschiedenen Holzarten und Verlegemustern.' },
      { title: 'Laminat', description: 'Strapazierfähige Laminatböden in authentischer Holzoptik.' },
      { title: 'Vinyl & Designbeläge', description: 'Moderne Vinylböden – wasserfest, pflegeleicht und vielseitig.' },
      { title: 'Kork & Linoleum', description: 'Natürliche Bodenbeläge für nachhaltiges Wohnen.' },
      { title: 'Untergrundvorbereitung', description: 'Professionelle Vorbereitung für optimale Verlegeergebnisse.' },
      { title: 'Sockelleisten', description: 'Passende Sockelleisten für den perfekten Abschluss.' }
    ],
    benefits: [
      'Fachgerechte Verlegung nach Herstellervorgaben',
      'Beratung zur optimalen Bodenwahl',
      'Langjährige Erfahrung im Bodenhandwerk',
      'Saubere und staubfreie Arbeitsweise',
      'Garantie auf unsere Verlegearbeiten',
      'Attraktive Komplettangebote'
    ],
    process: [
      { title: 'Beratung', description: 'Vor-Ort-Termin mit Musterauswahl und Aufmass.' },
      { title: 'Vorbereitung', description: 'Untergrundprüfung, Ausgleich und Dämmung.' },
      { title: 'Verlegung', description: 'Präzise Verlegung nach höchsten Standards.' },
      { title: 'Finish', description: 'Sockelleisten, Übergangsprofile und Endreinigung.' }
    ],
    gallery: [
      'https://images.unsplash.com/photo-1769736436809-eab3de70b175?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxwYXJxdWV0JTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb24lMjB3b29kJTIwZmxvb3IlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzc2NDMxODh8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1760706167627-2c5e98b47a0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxwYXJxdWV0JTIwZmxvb3JpbmclMjBpbnN0YWxsYXRpb24lMjB3b29kJTIwZmxvb3IlMjBpbnRlcmlvcnxlbnwwfHx8fDE3Nzc2NDMxODh8MA&ixlib=rb-4.1.0&q=85'
    ],
    metaKeywords: 'Bodenbeläge Graubünden, Parkett verlegen Cazis, Laminat Vinyl Bodenleger Schweiz'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Bodenbelaege;
